/** Class name used by legacy t-shared unstyled icon buttons. */
export const UNSTYLED_BUTTON_CLASS_NAME = 'unstyled-button';

/** Error name set by therapies axios impersonation interceptor (mirrors t-shared). */
export const IMPERSONATION_ERROR_CODE = 'IMPERSONATION_ERROR_CODE';
